import { userAdmin, userClient } from "@/app/api";
import { ReactNode } from "react";

interface ClientAccessProps {
  children: ReactNode;
}

export async function ClientRoute({ children }: ClientAccessProps) {
  const isClient = await userClient();
  const isAdmin = await userAdmin();

  if (isClient || isAdmin) {
    return <>{children}</>
  }
  return null
}